export default "__VITE_ASSET__B$uH4BsU__"